import IconChevronRight from '@apollo/icons/default/IconChevronRight.svg';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import { PlainHtmlButton } from 'src/components/common/plainHtmlButton/PlainHtmlButton';

export function SubgraphListSection({
  label,
  children,
  showSectionDefault = true,
  hasLanguageServerErrors,
}: {
  label: React.ReactNode;
  children: React.ReactNode;
  showSectionDefault?: boolean;
  hasLanguageServerErrors: boolean;
}) {
  const [showSection, setShowSection] = useState(showSectionDefault);

  // When the default value becomes true,
  // we should override the current showSection state
  useEffect(() => {
    if (showSectionDefault) {
      setShowSection(showSectionDefault);
    }
  }, [showSectionDefault]);

  return (
    <div>
      <PlainHtmlButton
        className="focus-visible:focus-ring flex items-center"
        onClick={() => setShowSection(!showSection)}
      >
        <IconChevronRight
          className={classnames(
            'mr-2 transition-transform',
            showSection && 'rotate-90',
            hasLanguageServerErrors && !showSection
              ? 'text-red'
              : 'text-secondary',
          )}
        />
        <h3
          className={classnames(
            'py-2 text-xs font-semibold uppercase text-neutral',
            { 'text-red': hasLanguageServerErrors && !showSection },
          )}
        >
          {label}
        </h3>
      </PlainHtmlButton>
      {showSection && children}
    </div>
  );
}
